import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnGR: CultureInfo = {
  name: 'en-GR',
  displayName: 'English (Greece)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-GR',
  parent: CultureInfoEn
};
